import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import uploadImageToServer, {removeImageFromServer} from "../../utils/photoManager";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import moment from "jalali-moment";
import axios from "axios";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class CashUsersService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
        this.cancelToken = null
    }

    getCashUsersList(page, fundID, name, nationalCode, groupName, size = 20) {

        if (this.cancelToken) {
            this.cancelToken()
        }

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/funds/" + fundID + "/members",
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    size: size,
                    page: page,
                    "full-name": name,
                    "group-name": groupName,
                    "national-code": nationalCode
                },
                {},
                {
                    cancelToken: new axios.CancelToken(cancel => this.cancelToken = cancel)
                }
            ).then(response => {
                resolve(response)
            }).catch(reason => {
                reject(reason)
            })
        })
    }

    addNewUser(
        fundID,
        imageFile,
        name,
        lastName,
        userName,
        password,
        isMale,
        nationalCode,
        personalCode,
        phoneNumber,
        fixedNumber,
        birthday,
        education,
        job,
        groupSelectedID,
        address,
        enabled,
        clearFields) {

        this.loading(setLoadingStateDispatch(true))

        if (imageFile !== null) {
            this.uploadImage(imageFile)
                .then(response => {
                    this.doAddNewUser(
                        fundID,
                        response.id,
                        name,
                        lastName,
                        userName,
                        password,
                        isMale,
                        nationalCode,
                        personalCode,
                        phoneNumber,
                        fixedNumber,
                        birthday,
                        education,
                        job,
                        groupSelectedID,
                        address,
                        enabled,
                        clearFields
                    )
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در افزودن تصویر کاربر", this.snackbar, this.loading)
            })
        } else {
            this.doAddNewUser(
                fundID,
                isMale ? 1 : 2,
                name,
                lastName,
                userName,
                password,
                isMale,
                nationalCode,
                personalCode,
                phoneNumber,
                fixedNumber,
                birthday,
                education,
                job,
                groupSelectedID,
                address,
                enabled,
                clearFields
            )
        }

    }

    doAddNewUser(fundID, imageId, name, lastName,
                 userName,
                 password, isMale,
                 nationalCode, personalCode,
                 phoneNumber, fixedNumber, birthday,
                 education, job, groupSelectedID,
                 address, enabled, clearFiled) {
        this.httpClient.post(
            `fund-presentation/funds/${fundID}/groups/${groupSelectedID}/members`,
            prepareUsersDataModel(
                fundID, imageId, name, lastName,
                userName,
                password, isMale, nationalCode, personalCode,
                phoneNumber, fixedNumber, birthday,
                education, job, address, enabled),
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFiled()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "کاربر جدید با موفقیت افزوده شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.deleteAvatar(imageId)
            ServerErrorHandler(reason, "خطا در افزودن کاربر جدید!", this.snackbar, this.loading)
        })
    }

    getUserInfo(fundID, selectedItemId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/members/${selectedItemId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve)
                .catch(reject)
        })
    }

    changeUserInfo(
        fundID, memberId, imageFile, imageId, firstName,
        lastName, username, password, isMale,
        nationalCode, personalCode, phoneNumber,
        fixedNumber, birthday, education, job,
        groupSelectedID, address, enabled) {

        this.loading(setLoadingStateDispatch(true))

        if (imageFile !== null) {
            this.uploadImage(imageFile)
                .then(response => {
                    this.doUpdateUser(
                        fundID,
                        memberId,
                        response.id,
                        firstName,
                        lastName,
                        username,
                        password,
                        isMale,
                        nationalCode,
                        personalCode,
                        phoneNumber,
                        fixedNumber,
                        birthday,
                        education,
                        job,
                        groupSelectedID,
                        address,
                        enabled,
                        true
                    )
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در افزودن تصویر کاربر", this.snackbar, this.loading)
            })
        } else {
            this.doUpdateUser(
                fundID,
                memberId,
                imageId,
                firstName,
                lastName,
                username,
                password,
                isMale,
                nationalCode,
                personalCode,
                phoneNumber,
                fixedNumber,
                birthday,
                education,
                job,
                groupSelectedID,
                address,
                enabled
            )
        }
    }

    doUpdateUser(
        fundID, memberId, imageId, firstName, lastName, username,
        password, isMale, nationalCode, personalCode,
        phoneNumber, fixedNumber, birthday, education,
        job, groupSelectedID, address, enabled, isUploadNewAvatar = false) {

        //check if it is default image id set it by gender ...
        let userImageId = 1
        if (parseInt(imageId) < 3) {
            userImageId = isMale === true ? 1 : 2
        } else
            userImageId = imageId


        this.httpClient.put(
            `fund-presentation/funds/${fundID}/members/${memberId}/groups/${groupSelectedID}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            prepareUsersDataModel(
                fundID, userImageId, firstName, lastName,
                username, password, isMale, nationalCode, personalCode,
                phoneNumber, fixedNumber, birthday,
                education, job, address, enabled
            )
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروز رسانی کاربر با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            if (isUploadNewAvatar) {
                this.deleteAvatar(imageId)
            }
            ServerErrorHandler(reason, "خطا در ویرایش اطلاعات کاربر!", this.snackbar, this.loading)
        })


    }

    uploadImage(imageFile) {
        return new Promise((resolve, reject) => {
            uploadImageToServer("fund-presentation/avatars", this.token, imageFile)
                .then(resolve).catch(reject)
        })
    }

    deleteAvatar(imageID) {
        removeImageFromServer("fund-presentation/avatars/", this.token, imageID)
            .then(resolve => {

            }).catch(reject => {

        })
    }

    updateUsername(fundID, userId, newUsername) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.put(
            `fund-presentation/funds/${fundID}/members/${userId}/username`,
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                newUsername
            }
        ).then(response => {
            this.loading(setLoadingStateDispatch(false))
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی نام کاربری با موفقیت انجام شد."))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی نام کاربری!", this.snackbar, this.loading)
        })
    }

    updateUserPassword(fundID, userId, newPassword) {
        this.loading(setLoadingStateDispatch(true))

        let formData = new URLSearchParams()
        formData.append("newPassword", newPassword)


        this.httpClient.put(
            `fund-presentation/funds/${fundID}/members/${userId}/password`,
            this.httpClient.prepareUserAccessHeader(this.token),
            formData
        ).then(response => {
            this.loading(setLoadingStateDispatch(false))
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی نام کاربری با موفقیت انجام شد."))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی نام کاربری!", this.snackbar, this.loading)
        })
    }
}

function prepareUsersDataModel(
    fundID, imageID, name, lastName,
    userName, password, isMale, nationalCode, personalCode,
    phoneNumber, fixedNumber, birthday,
    education, job, address, enabled) {
    return {
        "firstName": name,
        "lastName": lastName,
        "username": userName && userName.length > 0 ? userName : null,
        "password": password && password.length > 0 ? password : null,
        "enabled": enabled,
        "gender": isMale,
        "phoneNumber": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
        "nationalCode": nationalCode,
        "birthdate": birthday && birthday.length > 0 ? moment.from(birthday, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : null,
        "degreeEducation": education && education.length > 0 ? education : null,
        "jobTitle": job && job.length > 0 ? job : null,
        "tellNumber": fixedNumber && fixedNumber.length > 0 ? fixedNumber : null,
        "nBirthCertificate": personalCode && personalCode.length > 0 ? personalCode : null,
        "postalAddress": address && address.length > 0 ? address : null,
        "avatarId": imageID
    }
}
